import { useEffect, useState, useCallback } from "react";
import { useTranslate } from "src/locales";
import { axiosInstance } from "src/api/config/axiosInstance";
import ByzAsynchronousSelectV2 from "src/components/core-components/ByzAsynchronousSelectV2";

interface NurseDto {
    id: number;
    name: string;
    surname: string;
}

interface ByzNurseListProps {
    handleChange: (value: NurseDto | NurseDto[] | null) => void;
    multiple?: boolean;
    value?: NurseDto | NurseDto[] | null;
    sx?: any;
    offId?: number;
    deptId?: number;
    disabled?: boolean;
    placeholder?: string;
}

export default function ByzNurseList({
    handleChange,
    multiple = false,
    value,
    sx,
    offId,
    deptId,
    disabled = false,
    placeholder,
}: ByzNurseListProps) {
    const [selectedNurse, setSelectedNurse] = useState<NurseDto | NurseDto[] | null>(
        value ?? null
    );

    const { t } = useTranslate();

    useEffect(() => {
        setSelectedNurse(value ?? null);
    }, [value]);

    useEffect(() => {
        setSelectedNurse(null);
        handleChange(null);
    }, [offId, deptId]);

    const fetchNurses = useCallback(async (): Promise<NurseDto[]> => {
        try {
            const response = await axiosInstance.get("/nurse/api/Nurse/GetNurseList", {
                params: { offId, deptId }
            });
            if (response.data && response.data.data) {
                return response.data.data;
            }
            return [];
        } catch (error) {
            console.error("Failed to fetch nurse list", error);
            return [];
        }
    }, [offId, deptId]);

    return (
        <ByzAsynchronousSelectV2<NurseDto>
            fetchOptions={fetchNurses}
            label={t("nurse-list")}
            onChange={(value) => {
                setSelectedNurse(value);
                handleChange(value);
            }}
            value={selectedNurse}
            selectLabel="name,surname"
            multiple={multiple}
            sx={sx}
            disabled={disabled}
            placeholder={placeholder}
        />
    );
}
